module.exports = __webpack_public_path__ + "static/media/DOGS-2.475c3c91.jpg";